import React, {Component} from 'react';
import config from 'react-global-configuration';
import { Collapse, Button, Input, Form, FormGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
//import {Card, CardBody, CardText} from 'reactstrap';
import {Card} from 'react-bootstrap';
import {Link} from "react-router-dom";
import axios from "axios";
import "../assets/css/monthpicker/month-picker.css";
import NotificationSystem from "react-notification-system";
import {Nav, Navbar, NavItem} from "react-bootstrap";
import {style} from "variables/Variables.jsx";
import {css} from "@emotion/core";
import Select from 'react-select';
import {BeatLoader} from 'react-spinners';
import jwt_decode from "jwt-decode";
import ReactTooltip from 'react-tooltip';
import Switch from "react-switch";
import $ from 'jquery';
import CommonNavbar, {navbar} from "./commonNavbar";


const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;

class BrandMerchantProductMapper extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedFile: null,
            brand_file_uploaded: [],
            mvalue: { year: new Date().getFullYear(), month: 11 },
            _notificationSystem: null,
            timer: null,
            loading: true,
            isSubmit: false,
            file_name: "",
            notify: null,
            activer:[],
            is_download: false,
            uploadDropdown: false,
            errorModel: false,
            noErrorModel: false,
            file_id_got: null,
            report_file_name: null,
            error_message: null,
            error_message_header: null,
            open_instructions: false,
            emiMenus:[],
            party_options: [
                { value: 'Brand', label: 'Brand' },
                { value: 'Merchant', label: 'Merchant' }
            ],
            party_list: [],
            selected_party_type: null,
            selected_party: null,
            upload_user_type: null,
            raw_display_data: null
        };
        this.handleChange = this.handleChange.bind(this);
    }

    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    }

    componentDidMount() {
        this.setState({ 
            _notificationSystem: this.refs.notificationSystem,
            file_id: this.props.match.params.id
        });
        this.getPartyID();
    }

    refreshUnmappedView() {
        console.log("hello");
        axios.get(config.get('API_URL') + '/brandemi/get_unmapped_data_new',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                file_id: this.props.match.params.id
            }
        }).then(response => {
            console.log(response.data);
            this.setState({
                raw_display_data: response.data
            });
            this.setState({
                loading: false
            });
            this.preAppender();

        });
    }

    getPartyID(){
        if ($.fn.DataTable.isDataTable('#party_showTable')) {
            $('#party_showTable').DataTable().destroy();
        }
        console.log("hello2");
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.get(config.get('API_URL') + '/brandemi/get_party_id',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                user_id: decoded._id,
            }
        }).then(response => {
            //console.log(response.data);
            response.data.map((values, index) => {
                console.log(values.party_id);
                this.setState({
                    party_master_id: values.party_id,
                    upload_user_type: decoded.userGroup
                })
            })
            this.setState({
                party_id_mapper: response.data
            });
            $('#party_showTable').DataTable();
            this.setState({
                loading: false,
                user_id: decoded._id
            });
            this.refreshUnmappedView();
        });
    }
    
    getPartyList = () => {
        const token = localStorage.usertoken;
        axios.post(config.get('API_URL')+'/brandemi/get_party_list', {
                party_type1: this.state.selected_party_type
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            })
            .then(response => { console.log(response);
            let party_list = [];
            this.setState({
                party_list: [],
                selected_party: null
            });
            response.data.map((values, index) => {
                party_list.push({value: values.id, label: values.party_name})
            });
            this.setState({
                party_list: party_list,
                loading: false
            })
        });
    }

    updatePartyType = (valuer) => {
        if (valuer.value == 'Merchant'){
            this.setState({
                selected_party_type: valuer.value,
                uploadDropdown: false,
                upload_user_type: 2
            });
        }
        else if( valuer.value == 'Brand'){
            this.setState({
                selected_party_type: valuer.value,
                uploadDropdown: false,
                upload_user_type: 7
            });
        }
        this.setState({
            loading: true
        });
        this.getPartyList();
    }

    updatePartyValue = (valuer) => {
        this.setState({
            selected_party: valuer.value,
            party_master_id: valuer.value,
            loading: true,
            uploadDropdown: false
        });
    }


    getFileExtension(filename) {
        return (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0] : undefined;
    }

    openInstructions(){
        this.setState({
            open_instructions: !this.state.open_instructions
        });
        
    }

    onChangeHandler = event => {
        var file = event.target.files[0];
        var ext = this.getFileExtension(file.name);
        if (ext === 'csv') {
            this.setState({
                selectedFile: file,
                file_name: file.name
            });
        } else {
            this.handleNotificationClick("tr", 3, "Please upload valid file");
            this.setState({
                selectedFile: file
            });
        }
    };

    handleChange(checked) {
        console.log(this.state.checked);
        //console.log(e.target.value);
        this.setState({
            checked
        });
        //this.setState({
        //    changedItems: {...this.state.changedItems, [id]:e.target.value},
        //    isChange: true
        //});
    }

    mappingHandler = () => {
        this.setState({
            isSubmit: true,
            loading: true
        });
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        // console.log(decoded);
        const data = new FormData();
        data.append('file_id', this.state.file_id);
        data.append('userID', decoded._id);
        data.append('mappings', JSON.stringify(this.state.changedItems));
        data.append('userGroup', decoded.userGroup);
        console.log(data);
        axios.post(config.get('API_URL') + "/brandemi/map_data", data,{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        })
            .then(res => {
                console.log(res);
                if(res.data.success){
                    this.handleNotificationClick("tr", 1, res.data.success);
                    this.setState({
                        isSubmit:false,
                        loading:false
                    });

                } 
                else {
                    this.handleNotificationClick("tr", 3, res.data.error);
                    this.setState({
                        isSubmit:false,
                        loading:false
                    });
                }
            })
            .catch(err => { // then print response status
                this.handleNotificationClick("tr", 3, "Something Wrong!");
                this.setState({
                    isSubmit:false,
                    loading:false
                })
            })
        };

    downloadReportCSV = (file_id, file_value) => {
        this.setState({
            is_download:false
        });
        let xhr = $.ajax({
            url: config.get('API_URL') + "/brandemi/download_report_csv?file_id=" + file_value,
            type: 'GET',
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
            xhrFields: {
                responseType: 'blob'
            },
            success: function (response, status, xhr) {
                let blob = new Blob([response], {
                    type: "application/csv"
                });
                let fileName= file_value;
                console.log(file_value);
                console.log(xhr.getResponseHeader('Content-Disposition'));
                //alert(fileName);
                let rfile = fileName.replace(/\"/g, "");
                // console.log(fileName);
                let a = document.createElement('a');
                let url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = rfile;
                a.click();
                console.log(a);
                window.URL.revokeObjectURL(url);
                this.setState({
                    is_download: true
                })
            }.bind(this)
        });
        this.setState({
            xhr:xhr
        })
    };

    goBack = () => {
        this.props.history.push('/admin/brand-emi')
    }

    uploadDropdownHandler = () => {
        if (this.state.selected_party == null || this.state.selected_party_type == null){
            this.handleNotificationClick("tr", 3, "Please select a party");
        }
        else{
            this.setState({
                uploadDropdown: true
            })
        }
        
    }

    toggleErrorModel() {
        this.setState({
            errorModel: !this.state.errorModel
        });
    }

    downloadReport(){
        console.log(this.state.report_file_name);
        this.downloadReportCSV.bind(this, 1, this.state.report_file_name);
    }



    toggleNoErrorModel() {
        this.setState({
            noErrorModel: !this.state.noErrorModel
        });
    }

    gotoUploadedFile(){
        let pusher = '/admin/brand-viewer/' + this.state.file_id_got
        this.props.history.push(pusher)
    }

    

    preAppender(){
        this.state.raw_display_data.map((value, key) => {
            this.setState({
                changedItems: {...this.state.changedItems, [key]:value[1][0].sku + "$" + value[1][0].brand + "$" + value[1][0].description + "$" + value[1][0].mrp},
                isChange: false
            });
            return null;
        });
    }

    render() {
        console.log(this.state.selected_party_type);
        console.log(this.state.selected_party);

        let menus = this.state.emiMenus.map((menu, index) =>{
            return (
                <NavItem key={index} eventKey={index + "_" + 5} componentClass={Link} href={menu.layout+menu.path } to={menu.layout+menu.path}>
                    {menu.name}
                </NavItem>
            )
        });

        let unmapped_data = this.state.raw_display_data.map((value,index) => {
            //this.preAppender(this, value[0].item_no);
            //console.log(this.state.raw_display_data[index][1][0].sku);
            /*this.setState({
                changedItems: {...this.state.changedItems, [index]:this.state.raw_display_data[index][1][0].sku}//,
                //isChange: true
            });*/
            let optioner = value[1].map((value2,index) => {
                return(
                    <option value={value2.sku + "$" + value2.brand + "$" + value2.description + "$" + value2.mrp} key={index+1 + "_" + value2.sku}>{"sku: " + value2.sku + " brand: " + value2.brand + " desc: " + value2.description + " price: " + value2.mrp}</option>
                );
            });
            //let indicator = "All";
            return (
                    <tr key={index + 1}>
                    <td>{index+1}</td>
                    <td>{value[0].merchant_sku}</td>
                    <td>{value[0].merchant_description}</td>
                    <td>{value[0].merchant_mrp}</td>
                    <td>    
                        <select name="permissionType" className="form-control clmatch" onChange={this.handleChange.bind(this, value[0].item_no)}>
                            {/*console.log(value[0][1].brand)*/}
                            {/*, value[0].merchant_sku, value[0].merchant_brand, value[0].merchant_description, value[0].merchant_mrp*/}
                            {optioner}
                            {/*<option value="All" >{value[1][0].sku + " " + value[1][0].brand + " " + value[1][0].description + " " + value[1][0].mrp}</option>*/}
                            {/*selected={val.permission == "All"}*/}
                            {/*<option value="Self" >{value[1][1].sku + " " + value[1][1].brand + " " + value[1][1].description + " " + value[1][1].mrp}</option>*/}
                            {/*selected={val.permission=="Self"}*/}
                            {/*<option value="None">{value[1][2].sku + " " + value[1][2].brand + " " + value[1][2].description + " " + value[1][2].mrp}</option>*/}
                            {/* selected={val.permission=="None"}*/}
                            {/*<option value="None1">{value[1][3].sku + " " + value[1][3].brand + " " + value[1][3].description + " " + value[1][3].mrp}</option>*/}
                            {/*<option value="None2">{value[1][4].sku + " " + value[1][4].brand + " " + value[1][4].description + " " + value[1][4].mrp}</option>*/}
                        </select>
                    </td>
                </tr>
            )
        });

        let party_render = this.state.party_options;
        let party_render_list = this.state.party_list;

        return (
            <div className="content">
                <CommonNavbar/>
            <div className="card-query-builder p-t-5">
                <NotificationSystem ref="notificationSystem" style={style} />
                <ReactTooltip /> 
                <div className="col-md-12" >
                    <div className="card">
                        <div className='sweet-loading'>
                            <BeatLoader
                                css={override}
                                sizeUnit={"px"}
                                size={20}
                                color={'#123abc'}
                                loading={this.state.loading}
                            />
                        </div>
                        <div className="header">
                            <h4 className="title pull-left">Products</h4>
                            <button onClick={this.uploadDropdownHandler} className="btn btn-primary btn-capitalize pull-right">Import</button>
                        </div>
                        
                        <div className="content">
                            <div className="row">
                                <div className="col-md-4">
                                    <Label>Select party type</Label>
                                    <Select name={"party_type"}
                                        // defaultValue={this.state.selectedMerchValues}
                                        onChange={this.updatePartyType.bind(this)}
                                        options={party_render}
                                        placeholder="Select party type"
                                        // isClearable={true}
                                    />
                                </div>  
                                <div className="col-md-4">
                                    <Label>Select party</Label>
                                    <Select name={"party_name"}
                                        // defaultValue={this.state.selectedMerchValues}
                                        onChange={this.updatePartyValue.bind(this)}
                                        options={party_render_list}
                                        placeholder="Select party"
                                        // isClearable={true}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <Label>Select category</Label>
                                    <Select name={"party_name"}
                                        // defaultValue={this.state.selectedMerchValues}
                                        onChange={this.updatePartyValue.bind(this)}
                                        options={party_render_list}
                                        placeholder="Select party"
                                        // isClearable={true}
                                    />
                                </div> 
                                <div className="col-md-4">
                                    <button onClick={this.activeHandler} className="btn btn-primary btn-capitalize pull-right">Update</button>
                                    <button onClick={this.activeHandler} className="btn btn-primary btn-capitalize pull-right">Update</button>
                                </div> 
                            </div>
                        </div>
                    </div>
                </div>
                <Collapse isOpen={this.state.uploadDropdown}>
                    <div className="card">
                        <div className="content">
                            <div className='sweet-loading'>
                                <BeatLoader
                                    css={override}
                                    sizeUnit={"px"}
                                    size={20}
                                    color={'#123abc'}
                                    loading={this.state.loading}
                                />
                            </div>
                            <div className="content table-full-width table-responsive">
                                <div className="row">
                                    <div classname="col-md-12">
                                        <table className="table table-striped table-hover" id="unmappedViewTable">
                                            <thead>
                                            <tr>
                                                <th>Sr No.</th>
                                                <th>Merchant SKU</th>
                                                <th>Merchant Description</th>
                                                <th>Merchant Price</th>
                                                <th>Closest Brand Data Match</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {unmapped_data}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <Button color="primary" onClick={this.mappingHandler}>Map Data</Button>{' '}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Collapse>
            </div>
        </div>
        );
    }
}

export default BrandMerchantProductMapper;